import { getStrengths } from '~/util/npc';
import { EntityTooltip } from '../site/Tooltip';
import { Icon16 } from '../ui/Icon';

export function NpcStrengths(props: {
  skills: {
    id: number;
    skillName: string;
    level: number | null;
    name: string;
    icon: string;
  }[];
}) {
  return <div style={{ display: "flex", gap: 8 }}>
    {getStrengths(props.skills).map((s, index) => (
      <EntityTooltip
        key={index}
        what={{ t: "skill", uname: `${s.id}_${s.level}` }}
      >
        {({ setReference, getReferenceProps }) => (
          <div
            ref={setReference}
            {...getReferenceProps({
              style: {
                display: "flex",
              },
            })}
          >
            <Icon16 icon={s.icon} alt={s.name} />
          </div>
        )}
      </EntityTooltip>
    ))}
  </div>;
}